export default __webpack_public_path__ + "static/media/planetmovie.5444cb24.jpg";